<template>
  <div class="account-settings">
    <h1 class="settings-title">
      Change Email
    </h1>
    <div class="settings-form">
      <div>
        <b-form-group>
          <label
            for="email"
            class="settings-label">
            Email
          </label>
          <b-input
            id="email"
            v-model="email"
            v-validate="'required|email'"
            data-vv-validate-on="input"
            name="email"
            data-vv-as="Email"
            type="email"
            placeholder="name@email.com"
            autofocus/>
        </b-form-group>
        <span
          v-if="errors.has('email')"
          class="validation-error">{{ errors.first('email') }}</span>
        <span
          v-if="validationErrors.email"
          class="validation-error">{{ validationErrors.email }}</span>
      </div>
    </div>
    <div
      v-if="emailUpdated"
      class="account-settings__success">
      Email has been successfully updated.
    </div>
    <div
      v-if="errorMessage"
      class="account-settings__error">
      {{ errorMessage }}
    </div>
    <b-button
      :class="{loading: saving}"
      :disabled="saving || !fieldsValid"
      class="account-settings__submit btn-round"
      @click="getConfirmation">
      <span v-if="!saving">Save</span>
      <div class="loader"><div class="loading-circle"/></div>
    </b-button>
  </div>
</template>

<style lang="scss">
.verify {
  font-size: 12px;
  padding-left: 10px;
}

.input-group-btn {
  background: $bluePrimary;
  color: white;
  border: none;

  &:hover {
    background: $bluePrimary;
  }
}
</style>

<script>
import setValidationErrors from '@/helpers/validationErrors';
import { mapActions, mapGetters } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'user/getField',
  mutationType: 'user/updateField',
});

export default {
  name: 'EmailSettings',
  data() {
    return {
      password: '',
      errorMessage: '',
      saving: false,
      emailUpdated: false,
      validationErrors: {},
      waitingForUpdate: false,
    };
  },
  computed: {
    ...mapGetters({
      userLoaded: 'user/userLoaded',
      successEmailUpdate: 'user/successEmailUpdate',
      apiError: 'user/apiError',
    }),
    ...mapFields([
      'email',
      // 'phone',
    ]),
    fieldsValid() {
      return (this.veeFields && this.veeFields.email && this.veeFields.email.valid);
    },
  },
  watch: {
    successEmailUpdate(success) {
      if (success) {
        this.saving = false;
        this.emailUpdated = true;
        setTimeout(() => {
          this.emailUpdated = false;
        }, 3000);
        this.fetchUser();
      }
    },
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else if (error.status === 401) {
        this.errorMessage = 'Authentication failed. Wrong Password.';
      } else {
        this.errorMessage = error.data ? error.data.message : '';
      }
    },
    userLoaded() {
      this.waitingForUpdate = false;
    },
  },
  mounted() {
    if (!this.userLoaded) {
      this.fetchUser();
    }
  },
  beforeDestroy() {
    this.fetchUser();
  },
  methods: {
    ...mapActions({
      fetchUser: 'user/fetchUser',
      updateUserData: 'user/updateUserData',
    }),
    saveEmail() {
      this.waitingForUpdate = true;
      this.saving = true;
      const payload = {
        email: this.email,
      };
      this.updateUserData(payload);
    },
    getConfirmation() {
      this.errorMessage = '';
      this.validationErrors = {};
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$passwordConfirmPluginModal.show({
            confirmCallback: this.saveEmail,
          });
        }
      });
    },
  },
};
</script>
